"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var b=require("./queueMicroTask.js"),a=function(a){b.queueMicroTask(function(){requestAnimationFrame(a)})};exports.queueResizeObserver=a
//# sourceMappingURL=queueResizeObserver.js.map
